import { Box, Text, Image } from "@chakra-ui/react";
import React from "react";

function DropdownContent1() {
  return (
    <Box w="100%" padding="1rem" columnGap="5">
      <Box display={"flex"} textAlign="left" gap="70px" columnGap="8">
        <Text> CATEGORY</Text>
        <Text>TOP BRANDS</Text>
        <Text>DISCOVER</Text>
      </Box>
      <Box display={"flex"} gap="2" columnGap="9" lineHeight={2}>
        <Box textAlign="left">
          <Text>Dresses</Text>
          <Text>Tops</Text>
          <Text>Knitwear</Text>
          <Text>Jackets</Text>
          <Text>Coats</Text>
          <Text>Pants</Text>
          <Text>Skirts</Text>
          <Text>Jeans</Text>
        </Box>
        <Box textAlign="left">
          <Text>Dolce&Gabbana</Text>
          <Text>Acne Studios</Text>
          <Text>Balmain</Text>
          <Text>Bottega Veneta</Text>
          <Text>Burberry</Text>
          <Text>Dolce&Gabbana</Text>
          <Text>Gucci</Text>
          <Text>Jacquemus</Text>
        </Box>
        <Box textAlign="left">
          <Text>Tops</Text>
          <Text>New Arrivals</Text>
          <Text>Exclusives</Text>
          <Text>Essentials</Text>
          <Text>T-shirts</Text>
          <Text>Summer Dresses </Text>
        </Box>
        <Box>
          <Image
            src="https://img.mytheresa.com/media/static/raw/cms/l/WW_HP_2022_CW51/CW51_ActboxTall_2_2x_20221216121009.jpg?imwidth=600&imdensity=1"
            h="350px"
            w="300px"
            padding={"1rem"}
            mt="-2rem"
          />
        </Box>
      </Box>
    </Box>
  );
}

function DropdownContent2() {
  return (
    <Box w="100%" padding="1rem" columnGap="5">
      <Box display={"flex"} textAlign="left" gap="2" columnGap="8">
        <Text> CATEGORY</Text>
        <Text>TOP BRANDS</Text>
        <Text>DISCOVER</Text>
      </Box>
      <Box display={"flex"} gap="5" columnGap="8" lineHeight={2}>
        <Box textAlign="left">
          <Text>Sandals</Text>
          <Text>Sneakers</Text>
          <Text>Ankle Boots</Text>
          <Text>Boots</Text>
          <Text>Pumps</Text>
          <Text>Flat Shoes</Text>
        </Box>
        <Box textAlign="left">
          <Text>Amina Muaddi</Text>
          <Text>Balenciaga</Text>
          <Text>Bottega Veneta</Text>
          <Text>Christian Louboutin</Text>
          <Text>Gianvito Rossi</Text>
        </Box>
        <Box textAlign="left">
          <Text>New Arrivals</Text>
          <Text>Exclusives</Text>
          <Text>Essentials</Text>
          <Text>Fancy Flats</Text>
          <Text>Color Pop Shoes</Text>
        </Box>
        <Box>
          <Image
            src="https://img.mytheresa.com/media/static/raw/cms/l/SM_Monetate_Images/02_Product-Categories/Shoes/CW17_Pocket_Bridal_shoes_20220503153409.jpg"
            h="300px"
            padding={"1rem"}
          />
        </Box>
      </Box>
    </Box>
  );
}
function DropdownContent3() {
  return (
    <Box w="100%" padding="1rem" columnGap="5">
      <Box display={"flex"} textAlign="left" gap="2" columnGap="8">
        <Text> CATEGORY</Text>
        <Text>TOP BRANDS</Text>
        <Text>DISCOVER</Text>
      </Box>
      <Box display={"flex"} textAlign="left" lineHeight={"2"} columnGap="8">
        <Box textAlign="left">
          <Text>Shoulder Bags</Text>
          <Text>Crossbody Bags</Text>
          <Text>Tote Bags</Text>
          <Text>Clutches</Text>
          <Text>Evening Bags</Text>
        </Box>
        <Box textAlign="left">
          <Text>Dresses</Text>
          <Text>Balenciaga</Text>
          <Text>Bottega Veneta</Text>
          <Text>Burberry</Text>
          <Text>Chloé</Text>
        </Box>
        <Box textAlign="left">
          <Text>New Arrivals</Text>
          <Text>Exclusives</Text>
          <Text>Essentials</Text>
          <Text>Monogram Bags</Text>
        </Box>
        <Box>
          <Image
            src="https://img.mytheresa.com/media/static/raw/cms/l/SM_Monetate_Images/02_Product-Categories/Bags/CW17_Pocket_Color_pop_bags_20220426162915.jpg"
            h="300px"
            padding={"1rem"}
          />
        </Box>
      </Box>
    </Box>
  );
}

function DropdownContent4() {
  return (
    <Box w="80%" padding="1rem" columnGap="5">
      <Box display={"flex"} textAlign="left" columnGap="5">
        <Text>CATEGORY</Text>
        <Text>TOP BRANDS</Text>
        <Text>DISCOVER</Text>
      </Box>
      <Box display={"flex"} lineHeight={"2"} columnGap="9">
        <Box textAlign="left">
          <Text>Sunglasses</Text>
          <Text>Belts</Text>
          <Text>Hats</Text>
          <Text>Small Leather</Text>
          <Text>Scarves</Text>
          <Text>Hair Accessories</Text>
        </Box>
        <Box textAlign="left">
          <Text>Dresses</Text>
          <Text>Acne Studios</Text>
          <Text>Alexander </Text>
          <Text>Balenciaga</Text>
          <Text>Bottega Veneta</Text>
          <Text>Burberry</Text>
        </Box>
        <Box textAlign="left">
          <Text>New Arrivals</Text>
          <Text>Exclusives</Text>
          <Text>Essentials</Text>
          <Text>Chain Jewelry</Text>
          <Text>Iconic Belts</Text>
          <Text>Bridal Accessories</Text>
        </Box>
        <Box>
          <Image
            src="https://img.mytheresa.com/media/static/raw/cms/l/CAT_BANNERS_SS22/CAT_BANNERS_Desktop_2x_36_20220228112057.jpg?imwidth=1180&imdensity=1"
            ml="8rem"
            padding={"1rem"}
          />
        </Box>
      </Box>
    </Box>
  );
}

function DropdownContent5() {
  return (
    <Box w="100%" padding="1rem" columnGap="5">
      <Box display={"flex"} textAlign="left" lineHeight={2} columnGap="70px">
        <Text>TOP 20</Text>
        <Text>BRAND</Text>
        <Text>HIGHLIGHT</Text>
      </Box>
      <Box display={"flex"} lineHeight={2} columnGap="9">
        <Box textAlign="left" lineHeight={2}>
          <Text>Acne Studios</Text>
          <Text>Alexander </Text>
          <Text>Balenciaga</Text>
          <Text>Balmain</Text>
          <Text>Bottega Veneta</Text>
        </Box>
        <Box textAlign="left" lineHeight={2}>
          <Text>Gianvito Rossi</Text>
          <Text>Gucci</Text>
          <Text>Isabel Marant</Text>
          <Text>Isabel </Text>
        </Box>
        <Box textAlign="left" lineHeight={2}>
          <Text>Area</Text>
          <Text>Dior Eyewear</Text>
          <Text>Eéra</Text>
          <Text>Eres</Text>
          <Text>Gia </Text>
        </Box>
        <Box>
          <Image
            src="https://img.mytheresa.com/media/static/raw/cms/l/Designer_Bios/Acne-Studios/Image/Acne-Studios-SS22_2x_20220120152057.jpg?imwidth=1180&imdensity=1"
            h="300px"
            padding={"1rem"}
            ml="6rem"
          />
        </Box>
      </Box>
    </Box>
  );
}

function DropdownContent6() {
  return (
    <Box w="100%" padding="1rem">
      <Box display={"flex"} textAlign="left" gap="80px">
        <Text> CATEGORY</Text>
        <Text> BRANDS</Text>
        <Text>DISCOVER</Text>
      </Box>
      <Box display={"flex"} columnGap="9">
        <Box textAlign="left" lineHeight={2}>
          <Text>Fine Jewelry</Text>
          <Text>Demi-Fine Jewelry</Text>
          <Text>Fashion Jewelry</Text>
          <Text>Bracelets</Text>
          <Text>Earrings</Text>
          <Text>Necklaces</Text>
        </Box>
        <Box textAlign="left" lineHeight={2}>
          <Text>Eéra</Text>
          <Text>Gucci</Text>
          <Text>Ileana Makri</Text>
          <Text>Jade Trau</Text>
          <Text>Maria Tash</Text>
          <Text>Repossi</Text>
          <Text>Nadine Aysoy</Text>
        </Box>
        <Box textAlign="left" lineHeight={2}>
          <Text>New Arrivals</Text>
          <Text>Exclusives</Text>
          <Text>Chain Jewelry</Text>
          <Text>Colorful Jewelry</Text>
          <Text>Bridal Jewelry</Text>
        </Box>
        <Box>
          <Image
            src="https://img.mytheresa.com/media/static/raw/cms/l/CAT_BANNERS_SS22/CAT_BANNERS_Desktop_2x_38_20220228112053.jpg?imwidth=1180&imdensity=1"
            h="300px"
            padding={"1rem"}
          />
        </Box>
      </Box>
    </Box>
  );
}

export {
  DropdownContent1,
  DropdownContent2,
  DropdownContent3,
  DropdownContent4,
  DropdownContent5,
  DropdownContent6,
};
